import type { IconSvgObject } from './types';

const CopyleftIcon: IconSvgObject = [
  ["path", { d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 9.35418C9.73294 8.52375 10.8053 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C10.8053 16 9.73294 15.4762 9 14.6458", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CopyleftIcon;
